let dismissedForPageLoad = false;

export const isUserHomeGreetingDismissedForPageLoad = () =>
	dismissedForPageLoad;

export const dismissUserHomeGreetingForPageLoad = () => {
	dismissedForPageLoad = true;
};
